const ImageSizes = [
  ["sm", 50],
  ["md", 80],
  ["lg", 200],
];

// "//olds1.cdn107.com/images/defartist_md.png" =>
// "//olds1.cdn107.com/images/defartist_sm.png 50w,//olds1.cdn107.com/images/defartist_md.png 80w,//olds1.cdn107.com/images/defartist_lg.png 200w"
const defaultImageToSrcset = (default_image) => {
  //console.log("default_image:", default_image);

  if (default_image.match(/.*_md\.\w+$/)) {
    return ImageSizes.map((ext_size) => {
      return [
        default_image.replace("_md", `_${ext_size[0]}`),
        `${ext_size[1]}w`,
      ].join(" ");
    }).join();
  } else {
    return null;
  }
};

export default defaultImageToSrcset;
